import { HttpErrorResponse, HttpInterceptorFn, HttpRequest } from '@angular/common/http';
import { captureMessage } from '@sentry/browser';
import { throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';

export const sentryErrorInterceptor: HttpInterceptorFn = (request, next) => {
    return next(request).pipe(
        catchError((response: HttpErrorResponse) => {
            if (response instanceof HttpErrorResponse) {
                captureMessage(getMessage(request, response));
            }

            // re-throw error
            return throwError(() => response);
        }),
    );
};

function getMessage(request: HttpRequest<unknown>, response: HttpErrorResponse): string {
    const defaultMessage = 'Http request failed. ({method}, {status}, {url})';
    const replace = (msg: string) => {
        const map = {
            method: request.method,
            url: request.url,
            status: response.status.toString(),
            message: response.message,
        };

        // replace all keys with their values
        Object.keys(map).forEach((key) => {
            msg = msg.replace(new RegExp(`{${key}}`, 'g'), map[key]);
        });

        return msg;
    };

    // use default message
    return replace(defaultMessage);
}
